import PackageFocusElements from "@appsmith/navigation/FocusElements/PackageIDE";

export default PackageFocusElements;
